/**
 * Iter-181 — Inline "Ad · Sponsored" disclosure pill.
 *
 * FTC requires advertiser disclosures to be "clear and conspicuous"
 * and placed BEFORE/ABOVE the monetized action on the SAME viewport.
 * We already render `<AdvertiserDisclosure />` near comparison tables
 * and calculator output panels; this micro-pill is the inline variant
 * for any "Compare X" / affiliate-routed CTA in an intake form or
 * results card.
 *
 * Visual treatment is intentionally restrained — slate-500 micro-label
 * matching the existing iter-172 "MOST POPULAR" / "COMPARE" section
 * heads — so it reads as a deliberate compliance signal rather than
 * a banner.
 */
export default function AdPill({ testid = "ad-pill", className = "" }) {
  return (
    <p
      data-testid={testid}
      className={`text-[10px] font-bold uppercase tracking-[0.22em] text-slate-500 ${className}`.trim()}
    >
      Ad · Sponsored partner
    </p>
  );
}
